import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocalization } from '@ui-framework/index';
import DialogCloseButton from '@product-framework/components/Dialogs/DialogCloseButton';
import { IconLibrary } from '@product-framework/index';
import { DialogContent } from '@mui/material';
import LaborMatrixForm from './LaborMatrixForm';

function LaborMatrixRateRuleEditDialog({
  open,
  onClose,
  id,
  parentId,
  priority,
}) {
  const { formatMessage } = useLocalization();
  return (
    <Dialog open={open !== null} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.LaborMatrix />
        {formatMessage({
          id: 'LABOR_MATRIX_RATE',
          defaultMessage: 'Rate',
        })}
        <DialogCloseButton onClose={onClose} />
      </DialogTitle>
      <DialogContent>
        <LaborMatrixForm
          parentId={parentId}
          id={id}
          action={id !== -1 ? 'EDIT' : 'CREATE'}
          onClose={onClose}
          newPriority={priority}
        />
      </DialogContent>
    </Dialog>
  );
}

export default LaborMatrixRateRuleEditDialog;
